function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '@edusense/shared-auth-core';
import { ProjectCardCompact } from './ProjectCardCompact';
import { ProjectCardDefault } from './ProjectCardDefault';
/**
 * ProjectCard 컴포넌트 - 개별 프로젝트를 카드 형태로 표시합니다.
 * 
 * 아토믹 디자인의 생물체(Organism) 레벨 컴포넌트
 * variant="compact"로 설정하면 ContentBase.tsx에서 사용하기 적합한 간소화된 디자인 제공
 */ var ProjectCard = function(param) {
    var project = param.project, _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, onViewDetails = param.onViewDetails, onLike = param.onLike, onComment = param.onComment, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, onEdit = param.onEdit, onDelete = param.onDelete, onDuplicate = param.onDuplicate, onShare = param.onShare, onReport = param.onReport, _param_showActions = param.showActions, showActions = _param_showActions === void 0 ? true : _param_showActions, onClick = param.onClick;
    var isCompact = variant === 'compact';
    var _useState = _sliced_to_array(useState(false), 2), isMenuOpen = _useState[0], setIsMenuOpen = _useState[1];
    var _useAuth = useAuth(), currentUser = _useAuth.user, isAuthenticated = _useAuth.isAuthenticated;
    var isOwner = isAuthenticated && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === String(project.author.id);
    // 미디어 URL 처리 함수들
    var getUniqueMediaUrls = function(urls) {
        return Array.from(new Set(urls.filter(function(url) {
            return typeof url === 'string';
        })));
    };
    var getAllMediaUrls = function() {
        return getUniqueMediaUrls(project.mediaUrls || []);
    };
    var filterImageUrls = function(urls) {
        return urls.filter(function(url) {
            return url.match(/\.(jpg|jpeg|png|gif|webp)$/i);
        });
    };
    var filterVideoUrls = function(urls) {
        return urls.filter(function(url) {
            return url.match(/\.(mp4|webm|ogg|mov|avi|mkv|m3u8)$/i) || url.includes('.m3u8') || url.includes('video') || url.includes('/v/') || url.includes('watch');
        });
    };
    var filterShortFormUrls = function(urls) {
        return urls.filter(function(url) {
            return url.includes('shorts') || url.includes('reels') || url.includes('tiktok');
        });
    };
    // 모든 미디어 URL 가져오기
    var allMediaUrls = getAllMediaUrls();
    var hasMedia = allMediaUrls.length > 0;
    var handleViewDetails = function() {
        if (onViewDetails) {
            onViewDetails(project.id);
        }
    };
    var handleLike = function() {
        if (onLike) {
            onLike(project.id);
        }
    };
    var handleComment = function() {
        if (onComment) {
            onComment(project.id);
        }
    };
    var handleEdit = function() {
        if (onEdit) {
            onEdit(project.id);
        }
        setIsMenuOpen(false);
    };
    var handleDelete = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var originalProjectId, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isOwner) {
                            toast.error('프로젝트를 삭제할 권한이 없습니다.');
                            setIsMenuOpen(false);
                            return [
                                2
                            ];
                        }
                        if (!onDelete) {
                            toast.error('삭제 기능이 설정되지 않았습니다.');
                            setIsMenuOpen(false);
                            return [
                                2
                            ];
                        }
                        originalProjectId = project.id;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        // API 호출은 상위 컴포넌트의 onDelete 콜백에서 처리
                        return [
                            4,
                            onDelete(originalProjectId)
                        ];
                    case 2:
                        _state.sent();
                        toast.success('프로젝트가 성공적으로 삭제되었습니다.');
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Failed to delete project:", error);
                        toast.error('프로젝트 삭제 중 오류가 발생했습니다.');
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsMenuOpen(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDuplicate = function() {
        if (onDuplicate) {
            onDuplicate(project.id);
        }
        setIsMenuOpen(false);
    };
    var handleShare = function() {
        if (onShare) {
            onShare(project.id);
        }
        setIsMenuOpen(false);
    };
    var handleReport = function() {
        if (onReport) {
            onReport(project.id);
        }
        setIsMenuOpen(false);
    };
    var toggleMenu = function() {
        setIsMenuOpen(!isMenuOpen);
    };
    var handleMenuClose = function() {
        setIsMenuOpen(false);
    };
    // 공통 props
    var commonProps = {
        project: project,
        isMenuOpen: isMenuOpen,
        onMenuToggle: toggleMenu,
        onMenuClose: handleMenuClose,
        onViewDetails: handleViewDetails,
        onLike: handleLike,
        onComment: handleComment,
        onDelete: handleDelete,
        onReport: handleReport,
        onClick: onClick,
        className: className,
        showActions: showActions,
        isOwner: isOwner,
        isAuthenticated: isAuthenticated,
        hasMedia: hasMedia,
        allMediaUrls: allMediaUrls,
        filterImageUrls: filterImageUrls,
        filterVideoUrls: filterVideoUrls,
        filterShortFormUrls: filterShortFormUrls
    };
    if (isCompact) {
        return /*#__PURE__*/ React.createElement(ProjectCardCompact, commonProps);
    }
    return /*#__PURE__*/ React.createElement(ProjectCardDefault, commonProps);
};
export default ProjectCard;
